// Views
import HrUsersIndex from "../../Views/Hr/Users/Index";
import HrUsersLayout from "../../Views/Hr/Users/Layout";
import HrUsersLayoutTabs from "../../Views/Hr/Users/LayoutTabs";
import HrUsersForm from "../../Views/Hr/Users/Form";
import HrUsersShow from "../../Views/Hr/Users/Show";
import HrUsersChangeUsername from "../../Views/Hr/Users/ChangeUsername";
import HrUsersContractsLayout from "../../Views/Hr/Users/Contracts/Layout";
import HrUsersContractsIndex from "../../Views/Hr/Users/Contracts/Index";
import HrUsersContractsShow from "../../Views/Hr/Users/Contracts/Show";
import HrUsersContractsForm from "../../Views/Hr/Users/Contracts/Form";
import HrUsersContractsFinalize from "../../Views/Hr/Users/Contracts/Finalize";
import HrUsersTimeregistration from "../../Views/Hr/Users/Timeregistration";
import HrUsersOvertime from "../../Views/Hr/Users/Overtime";
import HrUsersOvertimeTotals from "../../Views/Hr/Users/OvertimeTotals";
import HrUsersVacationHours from "../../Views/Hr/Users/VacationHours";
import HrUsersDocuments from "../../Views/Hr/Users/Documents";

export default [
    {
        path:'/hr/users',
        component:HrUsersIndex,
        name:'hr.users.index',
    },
    {
        path:'/hr/users/add',
        component:HrUsersForm,
        name:'hr.users.add',
    },
    {
        path:'/hr/users/:uuid',
        component:HrUsersLayout,
        children:[
            {
                path:'',
                component:HrUsersLayoutTabs,
                children: [
                    {
                        path:'',
                        component:HrUsersShow,
                        name:'hr.users.show',
                    },
                    {
                        path:'timeregistration',
                        component:HrUsersTimeregistration,
                        name:'hr.users.timeregistration',
                    },
                    {
                        path:'overtime',
                        component:HrUsersOvertime,
                        name:'hr.users.overtime',
                    },
                    {
                        path:'overtime/totals',
                        component:HrUsersOvertimeTotals,
                        name:'hr.users.overtime.totals',
                    },
                    {
                        path:'vacationhours',
                        component:HrUsersVacationHours,
                        name:'hr.users.vacationhours',
                    },
                    {
                        path:'documents',
                        component:HrUsersDocuments,
                        name:'hr.users.documents',
                    },
                    {
                        path:'contracts',
                        component:HrUsersContractsLayout,
                        children:[
                            {
                                path:'',
                                name:'hr.users.contracts',
                                component:HrUsersContractsIndex,
                            },
                        ]
                    },
                    {
                        path:'edit',
                        component:HrUsersForm,
                        name:'hr.users.edit',
                    },
                ]
            },
            {
                path:'username',
                component:HrUsersChangeUsername,
                name:'hr.users.changeusername',
            },
            {
                path:'contracts',
                component:HrUsersContractsLayout,
                children:[
                    {
                        path:'add',
                        name:'hr.users.contracts.add',
                        component:HrUsersContractsForm,
                    },
                    {
                        path:':contract_uuid',
                        name:'hr.users.contracts.show',
                        component:HrUsersContractsShow,
                    },
                    {
                        path:':contract_uuid/edit',
                        name:'hr.users.contracts.edit',
                        component:HrUsersContractsForm,
                    },
                    {
                        path:':contract_uuid/finalize',
                        name:'hr.users.contracts.finalize',
                        component:HrUsersContractsFinalize,
                    },
                ]
            },
        ]
    },
];
